import React from 'react';
import 'layout/login.scss';

import {FTUComponent, FTUTrans} from 'components/FTUComponent';
import {withTranslation} from 'react-i18next';
import {
    Card,
    CardBody,
    CardGroup,
    Col,
    Container,
    Row
} from "reactstrap";


class Permission extends FTUComponent {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: ''
        };
    }

    render() {
        const logo = process.env.PUBLIC_URL +  '/assets/layout/images/mbf-logo.png';
        const backgroud = 'url('+ process.env.PUBLIC_URL + '/assets/layout/images/backgroud.png) no-repeat fixed center';

        return (
            <div style={{background: backgroud}} className="app flex-row align-items-center">
                <Container className="content-section introduction growl-demo">
                    <Row className="justify-content-center">
                        <Col md="8">
                            <CardGroup>
                                <Card className="p-4">
                                    <CardBody>
                                        <center>
                                        <h2><font color={"red"}><FTUTrans ns="login" name={this.props.match.params.error_code}/></font></h2>
                                        <h3><a href={"/login"}><FTUTrans ns="login" name={"Auto_Logout_Notify"}/></a></h3>
                                        </center>
                                    </CardBody>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withTranslation("login")(Permission);